import {
  FLIGHTS_EXPERT_COOKIE_AUTH_KEY,
  FLIGHTS_EXPERT_CLIENT_ID
} from '@stencil/flights-constants';
import getCookie from './get-cookie';

const OAUTH_GOIBIBO = getCookie('OAUTH-GOIBIBO');
const FLIGHT_EXPERT_TOKEN = getCookie(FLIGHTS_EXPERT_COOKIE_AUTH_KEY);
const mcid = getCookie('gi_mcid');

const getCommonHeaders = () => {
  return {
    ...(OAUTH_GOIBIBO && { 'OAUTH-GOIBIBO': OAUTH_GOIBIBO }),
    ...(FLIGHT_EXPERT_TOKEN && {
      'OAUTH-GOIBIBO': FLIGHT_EXPERT_TOKEN,
      'x-gommt-client-id': FLIGHTS_EXPERT_CLIENT_ID
    }),
    ...(mcid && { mcid })
  };
};

export default getCommonHeaders;
